export const NAV_ITEMS = [
  { label: "Inicio", href: "/" },            // 👈 Home
  { label: "Venta", href: "/venta" },
  { label: "Caja", href: "/caja" },
  { label: "Reportes", href: "/reportes" },
  { label: "Almacén", href: "/almacen" },
  { label: "Productos", href: "/productos" },
  { label: "Sustitutos", href: "/sustitutos" },
  { label: "Proveedores", href: "/proveedores" },
  { label: "Cotizaciones", href: "/cotizaciones" },
  { label: "Configuración", href: "/config" },
];
